<template>
  <!-- ホーム画面 -->
  <div id="guestHome">
    <div v-if="approvalCount != 0">
      <div class="infoContents">
        <slot>
          <span style="color: black"
            >CPAP処方・配送サービス 指示書承認待ちの申請が{{
              approvalCount
            }}件あります。<a class="link" style="color: blue" v-on:click="goToCpapRequestList"
              >CPAP処方申込履歴</a
            >から指示書承認待ちを検索して承認お願いします。</span
          >
          <a
            style="font-size: 12px; border: 1px solid #999; float: right"
            v-on:click="closeMessage"
            >ｘ</a
          >
        </slot>
      </div>
    </div>
    <div class="home-container-center">
      <div class="grid-area">
        <div class="grid-container">
          <ul class="home-tile-container" :class="{ 'home-tile-container_dev': env == 'development' || env == 'qa' }">
            <li
              v-if="
                isActive([
                  role.role_admin,
                  role.role_hospital,
                  role.role_dealer,
                  role.role_corporation,
                  role.role_accommodations,
                ]) &&
                (isEnableService(serviceId, service.hst) ||
                  isEnableService(serviceId, service.psg))
              "
            >
              <div class="contents">
                <router-link :to="{ name: 'kensaMenu', params: {} }">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-bed mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    睡眠検査・解析<br />ｻｰﾋﾞｽ申込み
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([
                  role.role_admin,
                  role.role_hospital,
                  role.role_dealer,
                  role.role_corporation,
                  role.role_accommodations,
                ]) && isEnableService(serviceId, service.holter)
              "
            >
              <div class="contents">
                <router-link :to="{ name: 'holterMenu', params: {} }">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-heart-pulse mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    ホルター心電図検査・解析<br />ｻｰﾋﾞｽ申込み
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([
                  role.role_admin,
                  role.role_hospital,
                  role.role_corporation,
                  role.role_dealer,
                  role.role_accommodations,
                ]) && isEnableService(serviceId, service.kenshin)
              "
            >
              <div class="contents">
                <router-link :to="{ name: 'KenshinRequest', params: {} }">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-office-building mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    <template v-if="roleId != role.role_accommodations"
                      >企業検診申込み</template
                    ><template v-else>スクリーニング検査申込み</template>
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([
                  role.role_admin,
                  role.role_hospital,
                  role.role_dealer,
                ]) && isEnableService(serviceId, service.cpap)
              "
            >
              <div class="contents">
                <router-link :to="{ name: 'CpapMenu', params: {} }">
                  <span
                    class="icon"
                    style="color: #fff; width: 65px; height: 65px"
                  >
                    <img :src="require('@/assets/cpap-icon.png')" />
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    CPAP処方・配送ｻｰﾋﾞｽ申込み
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([role.role_admin, role.role_hospital]) && coType == 1
              "
            >
              <div class="contents">
                <router-link :to="{ name: 'CORegistRequest', params: {} }">
                  <span
                    class="icon"
                    style="color: #fff; width: 65px; height: 65px"
                  >
                    <img
                      :src="require('@/assets/care_orchestrator-icon.png')"
                    />
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    <span class="subtext12"
                      >ケア オーケストレーター利用申込み</span
                    >
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([role.role_admin, role.role_hospital]) && coType == 2
              "
            >
              <div class="contents">
                <router-link :to="{name:'COSettingHospital', params:{careOrchestratorInstitutionId:userInfo.coInstitutionId, certificationFlag:userInfo.coCertificationFlag}}">
                  <span class="icon" style="color: #fff; width: 65px; height: 65px;" >
                    <img :src="require('@/assets/care_orchestrator-icon.png')">
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    <span class="subtext12">ケア オーケストレーター設定</span>
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([role.role_admin, role.role_dealer]) && coType == 3
              "
            >
              <div class="contents">
                <router-link :to="{ name: 'CODealerMenu', params: {} }">
                  <span
                    class="icon"
                    style="color: #fff; width: 65px; height: 65px"
                  >
                    <img
                      :src="require('@/assets/care_orchestrator-icon.png')"
                    />
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    <span class="subtext12">ケア オーケストレーター</span>
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([
                  role.role_corporation,
                  role.role_hospital,
                  role.role_dealer,
                  role.role_accommodations,
                ]) &&
                (isEnableService(serviceId, service.hst) ||
                  isEnableService(serviceId, service.psg) ||
                  isEnableService(serviceId, service.kenshin) ||
                  isEnableService(serviceId, service.holter))
              "
            >
              <div class="contents">
                <router-link to="/guest/RequestFormList">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-text-box-multiple-outline mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">検査申請一覧</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_judgment])">
              <div class="contents">
                <router-link to="/guest/KenshinJudgment">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-scale-balance mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    企業検診<br />結果判定
                  </div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_analysis])">
              <div class="contents">
                <router-link to="/guest/PSGAnalysisOrder">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-clipboard-pulse-outline mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">PSG解析</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_analysis])">
              <div class="contents">
                <router-link to="/guest/HolterAnalysisResultGuest">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i class="mdi mdi-clipboard-outline mdi-48px"  style="position: relative;" ></i>
                    <i class="mdi mdi-heart-pulse mdi-20px" style="position: absolute;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">ホルター解析</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_analysis])">
              <div class="contents">
                <router-link :to="{ name: 'AnalysisReportGuest', params: {} }">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-file-document-outline mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">業務報告書</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_dealer])">
              <div class="contents">
                <router-link to="/guest/DealersFacilityManagement">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-home-city-outline mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">施設管理</div>
                </router-link>
              </div>
            </li>
            <li v-if="isActive([role.role_admin, role.role_holter_judgment])">
              <div class="contents">
                <router-link to="/guest/HolterAnalysisJudgment">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-scale-balance mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">
                    ホルター<br />心電図判定
                  </div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([
                  role.role_hospital,
                ]) &&
                isEnableService(serviceId, service.inspection_report)
              "
            >
              <div class="contents">
                <router-link to="/guest/inspectionReportList">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-file-download-outline mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">点検報告書一覧</div>
                </router-link>
              </div>
            </li>
            <li
              v-if="
                isActive([
                  role.role_admin,
                  role.role_hospital,
                  role.role_corporation,
                  role.role_dealer,
                  role.role_judgment,
                  role.role_holter_judgment,
                  role.role_analysis,
                  role.role_accommodations,
                ])
              "
            >
              <div class="contents">
                <router-link to="/guest/GuestSetting">
                  <span class="icon" style="color: #fff; height: 45px">
                    <i
                      class="mdi mdi-cog mdi-48px"
                      style="position: relative"
                    ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff">設定</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex-container">
        <div class="flex-item" v-if="listOfNoticeData.length > 0">
          <div class="content-title">お知らせ</div>
          <div class="a-left">
            <a class="view-all" @click="goToArticleList(1)">すべて見る </a>
          </div>
          <b-table :data="filterdListOfNoticeData" class="notice-table">
            <template slot-scope="props">
              <b-table-column field="title" label="タイトル">
                <a
                  @click="
                    showModal(
                      props.row.title,
                      props.row.content,
                      props.row.createdAt
                    )
                  "
                  >{{ props.row.title }}</a
                >
              </b-table-column>
              <b-table-column field="content" label="本文">
                {{ props.row.content }}
              </b-table-column>
            </template>
          </b-table>
          <div
            v-show="unreturnedHSTDeviceInfo || unreturnedCorpDeviceInfo"
            class="unreturned-device-info"
          >
            <ul class="unreturned-device-info-list">
              <li v-show="unreturnedHSTDeviceInfo">
                <b-icon
                  icon="alert-circle-outline"
                  style="color: #ffa40d"
                />睡眠検査で未返却機器があります。
              </li>
              <li v-show="unreturnedCorpDeviceInfo">
                <b-icon
                  icon="alert-circle-outline"
                  style="color: #ffa40d"
                />企業検診で未返却機器があります。
              </li>
            </ul>
          </div>
        </div>
        <div class="flex-item" v-if="listOfGuidanceData.length > 0">
          <div class="content-title">ご案内</div>
          <div class="a-left">
            <a class="view-all" @click="goToArticleList(2)"> すべて見る </a>
          </div>
          <b-table :data="filterdListOfGuidanceData" class="guidance-table">
            <template slot-scope="props">
              <b-table-column field="title" label="タイトル">
                <a @click="downloadFile(props.row.pdfFileUrl)">{{
                  props.row.title
                }}</a>
              </b-table-column>
              <b-table-column field="product_code" label="製品名">
                {{ props.row.productNames }}
              </b-table-column>
              <b-table-column label="PDF閲覧" centered>
                <a @click="downloadFile(props.row.pdfFileUrl)"
                  ><b-icon icon="clipboard-arrow-right-outline"
                /></a>
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="flex-item" v-if="listOfEventData.length > 0">
          <div class="content-title">学会・イベント情報</div>
          <div class="a-left">
            <a class="view-all" @click="goToArticleList(3)"> すべて見る </a>
          </div>
          <div class="event-news-container">
            <div class="event-news-item1">
              <a @click="downloadFile(listOfEventData[0].pdfFileUrl)"
                ><img
                  v-if="
                    listOfEventData.length > 0 &&
                    listOfEventData[0].imageFileUrl
                  "
                  :src="listOfEventData[0].imageFileUrl"
                  class="event-news-hero-img" />
                <img
                  v-else
                  src="@/assets/image-off-outline.svg"
                  class="event-news-hero-img"
              /></a>
              <div>
                {{ listOfEventData.length > 0 ? listOfEventData[0].title : "" }}
              </div>
            </div>
            <div class="event-news-item2-4">
              <b-table :data="filterdListOfEventData" class="event-table">
                <template slot-scope="props">
                  <b-table-column field="title" label="タイトル">
                    <a @click="downloadFile(props.row.pdfFileUrl)">{{
                      props.row.title
                    }}</a>
                  </b-table-column>
                  <b-table-column field="pdfUrl" label="PDF閲覧" centered>
                    <a @click="downloadFile(props.row.pdfFileUrl)"
                      ><b-icon icon="clipboard-arrow-right-outline"
                    /></a>
                  </b-table-column>
                  <b-table-column
                    filed="externalUrl"
                    label="関連サイト"
                    centered
                  >
                    <a
                      v-if="props.row.externalLinkUrl"
                      @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                      class="infoicon"
                      ><b-icon icon="earth-arrow-right"
                    /></a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="flex-item" v-if="listOfNewsData.length > 0">
          <div class="content-title">ニュース</div>
          <div class="a-left">
            <a class="view-all" @click="goToArticleList(4)"> すべて見る </a>
          </div>
          <div class="event-news-container">
            <div class="event-news-item1">
              <a @click="goToTitleLinkUrl(listOfNewsData[0].titleLinkUrl)"
                ><img
                  v-if="
                    listOfNewsData.length > 0 && listOfNewsData[0].imageFileUrl
                  "
                  :src="listOfNewsData[0].imageFileUrl"
                  class="event-news-hero-img" />
                <img
                  v-else
                  src="@/assets/image-off-outline.svg"
                  class="event-news-hero-img"
              /></a>
              <div>
                {{ listOfNewsData.length > 0 ? listOfNewsData[0].title : "" }}
              </div>
            </div>
            <div class="event-news-item2-4">
              <b-table :data="filterdListOfNewsData" class="news-table">
                <template slot-scope="props">
                  <b-table-column field="title" label="タイトル">
                    <a @click="goToTitleLinkUrl(props.row.titleLinkUrl)">{{
                      props.row.title
                    }}</a>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="flex-item" v-if="listOfProductData.length > 0">
          <div class="content-title">製品情報</div>
          <div class="a-left">
            <a class="view-all" @click="goToArticleList(5)"> すべて見る </a>
          </div>
          <b-table :data="filterdListOfProductData" class="product-table">
            <template slot-scope="props">
              <b-table-column field="title" label="タイトル">
                <a
                  v-if="props.row.pdfFileUrl"
                  @click="downloadFile(props.row.pdfFileUrl)"
                  >{{ props.row.title }}</a
                >
                <a
                  v-else-if="props.row.externalLinkUrl"
                  @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                  >{{ props.row.title }}</a
                >
              </b-table-column>
              <b-table-column field="product_code" label="製品名">
                {{ props.row.productNames }}
              </b-table-column>
              <b-table-column field="target_audience_code" label="対象者">
                {{ props.row.targetAudienceName }}
              </b-table-column>
              <b-table-column label="PDF閲覧" centered>
                <a
                  @click="downloadFile(props.row.pdfFileUrl)"
                  v-show="props.row.pdfFileUrl"
                  ><b-icon icon="clipboard-arrow-right-outline"
                /></a>
              </b-table-column>
              <b-table-column label="関連サイト" centered>
                <a
                  v-if="props.row.externalLinkUrl"
                  @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                  class="infoicon"
                  ><b-icon icon="play-box-multiple"
                /></a>
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="flex-item">
          <div class="content-title" style="height: auto">
            <div>無呼吸ラボはこちらから</div>
            <div class="lab-img">
              <a
                href="https://mukokyu-lab.jp/"
                target="_blank"
                rel="noopener noreferrer"
                ><img
                  src="@/assets/images/apnea-lab-banner-image.jpeg"
                  style="height: 180px"
              /></a>
            </div>
          </div>
        </div>
        <div class="terms-of-use-area">
          <div class="terms-of-use">
            <a
              href="https://www.philips.co.jp/a-w/terms-of-use"
              style="color: blue"
              >ご利用条件</a
            >
          </div>
          <div class="caveat">
            <span
              >本サイトの利用者は、利用条件を承認したとみなされますので、利用条件をご確認ください。</span
            >
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="caveatPasswordChange"
      @close="closeModal"
      has-modal-card
    >
      <caveatPasswordChange-modal></caveatPasswordChange-modal>
    </b-modal>
    <b-modal
      :active.sync="noticeModalActive"
      :width="640"
      :height="640"
      scroll="keep"
    >
      <div class="modal-notice">
        <div class="content">
          <div class="modal-headline">【お知らせ】</div>
          <div class="modal-title">「{{ modalTitle }}」</div>
          <div class="modal-content">{{ modalContent }}</div>
          <div class="modal-createdAt">{{ modalCreatedAt }}</div>
          <b-button class="is-primary" @click="noticeModalActive = false"
            >閉じる</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";
import { service } from "@/components/mock/base/const.js";

const caveatPasswordChangeForm = {
  props: [],
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var passwordLimit = userInfo.passwordLimit;
    return {
      userInfo,
      passwordLimit,
    };
  },
  methods: {
    inputAnswerYes: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$router.push({
        name: "GuestSetting",
        params: { passwordChange: true },
      });
      this.$parent.close();
    },
    inputAnswerNo: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$parent.close();
    },
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">パスワード変更依頼</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <div>
              <p>パスワードの有効期限がまもなく終了します。<br>
              「設定画面」からパスワードの変更をお願いいたします。<br>
              パスワード有効期限：{{passwordLimit}} まで</p>
            </div>
          </section>
          <footer class="modal-card-foot">
            <div>
            <b-button
              class="button is-primary is-inverted has-text-centered"
              type="button"
              v-on:click="inputAnswerYes"
            >
            はい
            </b-button>
            <b-button
              class="button is-light is-inverted has-text-centered"
              v-on:click="inputAnswerNo"
            >いいえ</b-button>
            </div>
          </footer>
        </div>
      `,
};

export default {
  name: "guestHome",
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var approvalCheck = userInfo.approvalCheck;
    var belongsId = userInfo.belongsId;
    var roleId = Number(userInfo.roleId);
    var serviceId = userInfo.useServiceId;
    var coType = userInfo.coType;
    var caveatPasswordChange = false;
    const env = this.$store.state.env;
    if (
      [
        role.role_admin,
        role.role_hospital,
        role.role_corporation,
        role.role_dealer,
        role.role_judgment,
        role.role_analysis,
        role.role_accommodations,
      ].indexOf(roleId) >= 0
    ) {
      if (
        userInfo.nearPasswordForceChange &&
        !userInfo.nearPasswordChangeAnswer
      ) {
        caveatPasswordChange = true;
      }
    }
    return {
      role: role,
      roleId: roleId,
      service: service,
      serviceId: serviceId,
      coType: coType,
      caveatPasswordChange,
      userInfo,
      approvalCount: 0,
      belongsId,
      approvalCheck,
      listOfNoticeData: [],
      listOfGuidanceData: [],
      listOfEventData: [],
      listOfNewsData: [],
      listOfProductData: [],
      filterdListOfNoticeData: [],
      filterdListOfGuidanceData: [],
      filterdListOfEventData: [],
      filterdListOfNewsData: [],
      filterdListOfProductData: [],
      noticeModalActive: false,
      modalTitle: "",
      modalContent: "",
      modalCreatedAt: "",
      unreturnedHSTDeviceInfo: "",
      unreturnedCorpDeviceInfo: "",
      env,
    };
  },
  methods: {
    isActive: function (roles) {
      return roles.indexOf(this.roleId) >= 0;
    },
    closeModal: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.caveatPasswordChange = false;
    },
    closeMessage: function () {
      this.approvalCount = 0;
    },
    goToArticleList(type) {
      this.$router.push({ path: "/guest/article-list?type=" + type });
    },
    goToExternalLinkUrl(externalLinkUrl) {
      const url = externalLinkUrl;
      window.open(url, "_blank");
    },
    goToTitleLinkUrl(titlelLinkUrl) {
      const url = titlelLinkUrl;
      window.open(url, "_blank");
    },
    goToCpapRequestList: function() {
      this.$router.push({ path: "/guest/cpap/CpapRequestList" });
    },
    gatApproval: async function () {
      // CPAP汎用コードマスタリストの取得
      var excuteApi = this.getCpapApprovalPendingCountPOST;
      var successCallBack = this.getCpapApprovalPendingCountPOSTSuccess;
      var errorCallBack = this.getCpapApprovalPendingCountPOSTError;
      // WebAPI Call
      return this.apiAnsyncCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapApprovalPendingCountPOST: function (client) {
      return client.apis.externalCpap.getCpapApprovalPendingCountPOST({
        body: { belongsId: this.belongsId },
      });
    },
    getCpapApprovalPendingCountPOSTSuccess: function (result) {
      this.approvalCount = result.obj.count;
      this.approvalCheck = true;
      this.userInfo.approvalCheck = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
    },
    getCpapApprovalPendingCountPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    searchUnreturnedDeviceInfo() {
      const THIS = this;
      return this.apiAnsyncCall(
        function (client) {
          return client.apis.portalHome.searchUnreturnedDeviceInfo();
        },
        function (success) {
          THIS.unreturnedHSTDeviceInfo = success.obj.isDelayedHSTDevice;
          THIS.unreturnedCorpDeviceInfo = success.obj.isDelayedCorpDevice;
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    showModal(title, content, createdAt) {
      this.modalTitle = title;
      this.modalContent = content;
      this.modalCreatedAt = createdAt;
      this.noticeModalActive = true;
    },
    // ホーム画面　掲載記事取得
    searchHomePortalArticles() {
      const THIS = this;
      return this.apiAnsyncCall(
        function (client) {
          return client.apis.portalHome.searchHomePortalArticles();
        },
        function (success) {
          if (success.obj.portalNoticeList) {
            THIS.listOfNoticeData = success.obj.portalNoticeList;
          } else {
            THIS.listOfNoticeData = 0;
          }
          for (let i = 0; THIS.listOfNoticeData.length > i; i++) {
            THIS.filterdListOfNoticeData.push(THIS.listOfNoticeData[i]);
            if (THIS.unreturnedHSTDeviceInfo || THIS.unreturnedCorpDeviceInfo) {
              if (i == 3) break;
            } else if (
              !(THIS.unreturnedHSTDeviceInfo || THIS.unreturnedCorpDeviceInfo)
            ) {
              if (i == 4) break;
            }
          }
          if (success.obj.portalGuidanceList) {
            THIS.listOfGuidanceData = success.obj.portalGuidanceList;
          } else {
            THIS.listOfGuidanceData = 0;
          }
          for (let i = 0; THIS.listOfGuidanceData.length > i; i++) {
            THIS.filterdListOfGuidanceData.push(THIS.listOfGuidanceData[i]);
            if (i == 4) break;
          }
          if (success.obj.portalEventList) {
            THIS.listOfEventData = success.obj.portalEventList;
          } else {
            THIS.listOfEventData = 0;
          }
          for (let i = 0; THIS.listOfEventData.length > i; i++) {
            if (i == 0) continue;
            THIS.filterdListOfEventData.push(THIS.listOfEventData[i]);
            if (i == 3) break;
          }
          if (success.obj.portalNewsList) {
            THIS.listOfNewsData = success.obj.portalNewsList;
          } else {
            THIS.listOfNewsData = 0;
          }
          for (let i = 0; THIS.listOfNewsData.length > i; i++) {
            if (i == 0) continue;
            THIS.filterdListOfNewsData.push(THIS.listOfNewsData[i]);
            if (i == 3) break;
          }
          if (success.obj.portalProductList) {
            THIS.listOfProductData = success.obj.portalProductList;
          } else {
            THIS.listOfProductData = 0;
          }
          for (let i = 0; THIS.listOfProductData.length > i; i++) {
            THIS.filterdListOfProductData.push(THIS.listOfProductData[i]);
            if (i == 2) break;
          }
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    downloadFile(fileAddress) {
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: 0,
              fileName: fileAddress,
            },
          });
        },
        function (result) {
          var downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;
          let targetFile = fileAddress.toLowerCase();
          if (targetFile.endsWith(".pdf")) {
            a.target = "_blank";
          }
          a.click();
          a.remove();
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
  },
  mounted() {
    if (this.role.role_hospital == this.roleId && !this.approvalCheck) {
      this.gatApproval();
    }
    this.searchHomePortalArticles();
    this.searchUnreturnedDeviceInfo();
  },
  components: {
    "caveatPasswordChange-modal": caveatPasswordChangeForm,
  },
};
</script>
<style lang="scss" scoped>
#guestHome {
  width: 100%;
  height: 100%;
  margin: -12px 0 0 -12px;
}
.home-container-center {
  width: auto;
}
.service-list {
  width: 100%;
}
.grid-area {
  display: grid;
  width: auto;
  margin: 0 auto;
  float: left;
}
.grid-container {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: 160px 1fr 100px;
  height: 0vh;
}
/*デザイン設定*/
.home-tile-container {
  list-style-type: none;
  margin: 0;
  padding: 0;
  flex-direction: column;
  background-color: #00629f;
  width: 160px;
}
.home-tile-container > li {
  height: 160px;
  width: 160px;
  background-color: #00629f;
  display: table-cell;
  text-align: center;
}
/*開発環境用デザイン設定*/
.home-tile-container_dev {
  list-style-type: none;
  margin: 0;
  padding: 0;
  flex-direction: column;
  background-color: rgb(240, 105, 217);
  width: 160px;
}
.home-tile-container_dev > li {
  height: 160px;
  width: 160px;
  background-color: rgb(240, 105, 217);
  display: table-cell;
  text-align: center;
}
.contents {
  display: table-cell;
  height: 160px;
  width: 160px;
  text-align: center;
  vertical-align: middle;
}
/*グリッド設定*/
.home-tile-container {
  display: grid;
  grid-template-columns: 160px;
  gap: 10px;
}
.subtext12 {
  font-size: 12px;
}
.infoContents {
  margin: 5px 8px 5px;
  --height: 30px;
  height: var(--height);
  // background-color: #fffbf0;
}
.link {
  text-decoration: underline;
}
.content-title {
  font-size: 25px;
  text-align: left;
}
.view-all {
  color: #1c29e6;
  font-size: 15px;
}
.a-left {
  text-align: left;
  margin: 5px 0 5px 0;
  text-align: left;
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 97%;
  height: auto;
  float: left;
  margin-top: 12px;
  margin-left: 172px;
}
.flex-item:nth-child(odd) {
  background-color: #d8eaff;
  margin: 0 10px 10px 0;
  padding: 5px;
  width: 47%;
  height: auto;
}
.flex-item:nth-child(even) {
  background-color: #d8eaff;
  margin: 0 0 10px 0;
  padding: 5px;
  width: 47%;
  height: auto;
}
.flex-item:last-child {
  background-color: #d8eaff;
  margin: 0 0 10px 0;
  padding: 5px;
  width: 47%;
  height: auto;
}
.info-icon {
  width: 24px;
}
/* PDFアイコンセンタリング*/
.table-wrapper > table > tbody > tr > td {
  vertical-align: middle;
}
.event-news-hero-img {
  object-fit: contain;
  height: 120px;
}
.event-news-container {
  display: grid;
  grid-template-columns: 30% 68%;
  grid-template-rows: auto;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas: "event-news-item1 news-item2-4";
}
.event-news-item1 {
  grid-area: event-news-item1;
  margin: 0 5px 0 0;
  background-color: #fff;
}
.news-item2-4 {
  grid-area: news-item2-4;
  height: auto;
}
/* ラベル名フォントサイズ */
.table-wrapper > table > thead {
  font-size: 12px;
  vertical-align: middle;
}
.table-wrapper > table > thead > tr > th > div {
  font-size: 12px;
  vertical-align: middle;
}
/* タイトル以外フォントサイズ */
.table-wrapper > table > tbody > tr > td > span {
  font-size: 12px;
  vertical-align: middle;
}
/* 掲載記事タイトルフォントサイズ */
.table-wrapper > table > tbody > tr > td > span > a {
  padding: auto;
  vertical-align: middle;
  font-size: 16px;
}
.table-wrapper > table > tbody > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lab-img {
  text-align: center;
  vertical-align: middle;
  height: auto;
}
.terms-of-use-area {
  width: 100%;
}
.terms-of-use {
  margin: auto;
  height: 50px;
  width: 100%;
  color: blue;
  padding: 20px;
  font-size: 18px;
}
.caveat {
  width: 100%;
  font-size: 15px;
  margin-bottom: 50px;
}
.content {
  background-color: #fff;
  margin: auto;
  padding: 36px;
}
.modal-headline {
  font-size: 36px;
  text-align: left;
  margin: 20px 0 20px 0;
}
.modal-title {
  font-size: 24px;
  text-align: left;
  margin: 0 0 2px 0;
}
.modal-content {
  font-size: 18px;
  text-align: left;
  margin: 0 0 50px 0;
}
.modal-createdAt {
  font-size: 16px;
  text-align: left;
  margin: 0 0 10px 0;
}
.unreturned-device-info {
  background-color: #fff;
  border: 2px solid #ffa40d;
  width: 100%;
  height: auto;
  margin-top: 5px;
}
.unreturned-device-info-list {
  text-align: left;
  margin: 2px;
}
</style>
<style>
#guestHome .b-table .table {
  table-layout: fixed;
}
/* notice-table */
#guestHome .notice-table .table > thead > tr > th:nth-child(1) {
  width: 60%;
}
/* guidance-table */
#guestHome .guidance-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#guestHome .guidance-table .table > thead > tr > th:nth-child(2) {
  width: 22%;
}
#guestHome .guidance-table .table > thead > tr > th:nth-child(3) {
  width: 8%;
}
/* event-table */
#guestHome .event-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#guestHome .event-table .table > thead > tr > th:nth-child(2) {
  width: 15%;
}
#guestHome .event-table .table > thead > tr > th:nth-child(3) {
  width: 15%;
}
/* product-table */
#guestHome .product-table .table > thead > tr > th:nth-child(1) {
  width: 47%;
}
#guestHome .product-table .table > thead > tr > th:nth-child(2) {
  width: 23%;
}
#guestHome .product-table .table > thead > tr > th:nth-child(3) {
  width: 12%;
}
#guestHome .product-table .table > thead > tr > th:nth-child(4) {
  width: 8%;
}
#guestHome .product-table .table > thead > tr > th:nth-child(5) {
  width: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/home.vue